import { render } from "./termUse.vue?vue&type=template&id=4cf15ea0"
import script from "./termUse.vue?vue&type=script&lang=js"
export * from "./termUse.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__